import { PlanTemplate } from "./SubCard";
import bronzeImg from "assets/plans/bronze.png";
import silverImg from "assets/plans/silver.png";
import goldImg from "assets/plans/gold.png";
import platinumImg from "assets/plans/platinum.png";

export const bronze: PlanTemplate = {
  id: 1,
  orderId: 1,
  header: {
    logo: bronzeImg,
    name: "Bronze",
    subText: "Just getting started",
  },
  access: [
    { textKey: "dashboardMetrics", isEnabled: true },
    { textKey: "recordSalesExpenses20", isEnabled: true },
    { textKey: "sendInvoices10", isEnabled: true },
    { textKey: "inventory10", isEnabled: true },
    { textKey: "shop10", isEnabled: true },
    { textKey: "collateralLoan", isEnabled: false },
    { textKey: "paymentReminders", isEnabled: false },
    { textKey: "employeePermissions", isEnabled: false },
    { textKey: "multipleUsers", isEnabled: false },
  ],
  price: {
    currency: "USD",
    duration: {
      ANNUAL: {
        cost: "0",
        save: "0",
        ios: "0",
        id: "0",
      },
      SEMI_ANNUAL: {
        cost: "0",
        save: "0",
        ios: "0",
        id: "0",
      },
      MONTH: {
        cost: "0",
        save: "0",
        ios: "0",
        id: "0",
      },
    },
  },
};

export const silver: PlanTemplate = {
  id: 2,
  orderId: 2,
  header: {
    logo: silverImg,
    name: "Silver",
    subText: "Manage your business",
  },
  access: [
    { textKey: "dashboardMetrics", isEnabled: true },
    { textKey: "recordSalesUnlimitedMonthly", isEnabled: true },
    { textKey: "sendInvoices25", isEnabled: true },
    { textKey: "inventory25", isEnabled: true },
    { textKey: "shop25", isEnabled: true },
    { textKey: "collateralLoan", isEnabled: true },
    { textKey: "paymentReminders", isEnabled: true },
    { textKey: "employeePermissions", isEnabled: false },
    { textKey: "multipleUsers", isEnabled: false },
  ],
  price: {
    currency: "$",
    duration: {
      ANNUAL: {
        cost: "35.99",
        save: "23.31%",
        ios: "35.99",
        id: "35.99",
      },
      SEMI_ANNUAL: {
        cost: "19.99",
        save: "16.67%",
        ios: "35.99",
        id: "35.99",
      },
      MONTH: {
        cost: "3.99",
        save: "more",
        ios: "35.99",
        id: "35.99",
      },
    },
  },
};

export const gold: PlanTemplate = {
  id: 3,
  orderId: 3,
  header: {
    logo: goldImg,
    name: "Gold",
    subText: "Grow your business",
  },
  access: [
    { textKey: "dashboardMetrics", isEnabled: true },
    { textKey: "recordSalesUnlimited", isEnabled: true },
    { textKey: "sendInvoicesUnlimited", isEnabled: true },
    { textKey: "inventoryUnlimited", isEnabled: true },
    { textKey: "shopUnlimited", isEnabled: true },
    { textKey: "collateralLoan", isEnabled: true },
    { textKey: "paymentReminders", isEnabled: true },
    { textKey: "employeePermissions", isEnabled: true },
    { textKey: "usersUpTo3", isEnabled: true },
  ],
  price: {
    currency: "$",
    duration: {
      ANNUAL: {
        cost: "89.99",
        save: "23.31%",
        ios: "35.99",
        id: "35.99",
      },
      SEMI_ANNUAL: {
        cost: "49.99",
        save: "16.67%",
        ios: "35.99",
        id: "35.99",
      },
      MONTH: {
        cost: "9.99",
        save: "more",
        ios: "35.99",
        id: "35.99",
      },
    },
  },
};

export const platinum: PlanTemplate = {
  id: 4,
  orderId: 4,
  header: {
    logo: platinumImg,
    name: "Platinum",
    subText: "Grow your business",
  },
  access: [
    { textKey: "dashboardMetrics", isEnabled: true },
    { textKey: "recordSalesUnlimited", isEnabled: true },
    { textKey: "sendInvoicesUnlimited", isEnabled: true },
    { textKey: "inventoryUnlimited", isEnabled: true },
    { textKey: "shopUnlimited", isEnabled: true },
    { textKey: "collateralLoan", isEnabled: true },
    { textKey: "paymentReminders", isEnabled: true },
    { textKey: "employeePermissions", isEnabled: true },
    { textKey: "usersUnlimited", isEnabled: true },
  ],
  price: {
    currency: "$",
    duration: {
      ANNUAL: {
        cost: "299.99",
        save: "23.31%",
        ios: "35.99",
        id: "35.99",
      },
      SEMI_ANNUAL: {
        cost: "124.99",
        save: "16.67%",
        ios: "35.99",
        id: "35.99",
      },
      MONTH: {
        cost: "24.99",
        save: "more",
        ios: "35.99",
        id: "35.99",
      },
    },
  },
};
